import Reveal from 'js/plugins/gsap/reveal';

const revealElements = [...document.querySelectorAll('[data-reveal]')];

revealElements.forEach((element) => new Reveal(element));
